import '../home-masthead.css';

import './img/rebrand_1680x400.jpg';
import './img/rebrand_800x400.jpg';

import '../../search/trending-searches/trending-searches';
